module.exports = __webpack_public_path__ + "img/EE.c0efdb96.svg";